import { Trans } from 'react-i18next'

export const STARTER_KIT_MATERIAL_NAME = 'Operation 36 Junior Starter Kit'
export const GOLF_CLUBS_MATERIAL_NAME = 'Operation 36 Golf Clubs'

// Each getter returns an i18n key; callers wrap with t() and pass { name: material.name }.
export const getOrderMessage = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'programs.materials.order.starterKit'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return 'programs.materials.order.golfClubs'
  } else {
    return 'programs.materials.order.default'
  }
}

export const getPositiveToggleText = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'programs.materials.positiveToggle.starterKit'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return 'programs.materials.positiveToggle.golfClubs'
  } else {
    return 'programs.materials.positiveToggle.default'
  }
}

export const getNegativeToggleText = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'programs.materials.negativeToggle.starterKit'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return 'programs.materials.negativeToggle.golfClubs'
  } else {
    return 'programs.materials.negativeToggle.default'
  }
}

export const getMaterialDescription = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return (
      <div>
        <Trans i18nKey='programs.materials.description.starterKit' components={{ b: <span className='font-weight-bold' /> }} />
      </div>
    )
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return (
      <>
        <div>
          <Trans i18nKey='programs.materials.description.golfClubsNeed' components={{ b: <span className='font-weight-bold' /> }} />
        </div>

        <div>
          <Trans i18nKey='programs.materials.description.golfClubsHave' components={{ b: <span className='font-weight-bold' /> }} />
        </div>
      </>
    )
  } else {
    return material.description
  }
}
